<template>
  <div class="menu-item-tile medicine-option">
    <span class="medicine-stripe" :class="stripeClass" :title="stripeTitle" />
    <div class="medicine-option-body">
      <div class="name">
        <strong class="text-primary">{{ item.title || item.name }}</strong>
        <span v-if="presentation">, {{ presentation }}</span>
      </div>
      <div class="description" v-if="item.description">{{ item.description }}</div>
    </div>
    <div class="medicine-option-maker">
      <template v-if="item.manufacturer">
        <div class="name text-ellipsis" :title="item.manufacturer">{{ item.manufacturer }}</div>
        <div class="description" v-if="ownership">{{ ownership }}</div>
      </template>
      <span class="description medicine-option-empty" v-else>—</span>
    </div>
  </div>
</template>

<script>
import { stripeTitle } from '@/helpers/medicine';

/**
 * Linha de medicamento no autocomplete: marca com a embalagem ou composição
 * com a forma farmacêutica, as substâncias embaixo e, à direita, o
 * laboratório e o tipo. A tarja vira o ícone à esquerda.
 */
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    presentation() {
      return this.item.caption || this.item.physicalForm;
    },
    ownership() {
      return this.item.ownership !== '—' ? this.item.ownership : '';
    },
    stripeClass() {
      return {
        'medicine-stripe-red': this.item.stripe === 'Vermelho',
        'medicine-stripe-black': this.item.stripe === 'Preto',
      };
    },
    stripeTitle() {
      return stripeTitle(this.item.stripe);
    },
  },
};
</script>

<style lang="scss">
  @import 'src/assets/scss/variables';

  .medicine-option {
    .medicine-stripe {
      background-color: #fff;
      border: $border-width solid $gray-color;
      border-radius: 50%;
      flex: 0 0 auto;
      height: 1.2rem;
      margin-right: $layout-spacing;
      position: relative;
      width: 1.2rem;
      &::after {
        background-color: $gray-color;
        border-radius: 1px;
        content: '';
        height: .25rem;
        left: .25rem;
        position: absolute;
        right: .25rem;
        top: 50%;
        transform: translateY(-50%);
      }
      &.medicine-stripe-red::after {
        background-color: #e53935;
      }
      &.medicine-stripe-black::after {
        background-color: #212121;
      }
    }
    .medicine-option-body {
      flex: 1 1 0;
      min-width: 0;
      .name {
        white-space: normal;
      }
    }
    .medicine-option-maker {
      flex: 0 0 7.5rem;
      margin-left: $layout-spacing-lg;
      min-width: 0;
    }
    @media (max-width: $size-sm) {
      flex-wrap: wrap;
      .medicine-option-maker {
        align-items: baseline;
        display: flex;
        flex-basis: 100%;
        margin-left: calc(1.2rem + #{$layout-spacing});
        .name {
          margin-right: $layout-spacing-sm;
        }
      }
      .medicine-option-empty {
        display: none;
      }
    }
  }

  .form-autocomplete .menu .menu-item:hover .medicine-option .description,
  .form-autocomplete .menu .menu-item-active .medicine-option .description {
    color: rgba($light-color, .8);
  }
</style>
